import {
	DBType,
	VIPCompany,
	VIPContact,
	VIPProject,
	IVIPCertificateContact
} from "@/loader";

export interface ITextToken {
	token: string;
	title: string;
	type: DBType;
	replace(item: any): string;
}

export const TOKENS: ITextToken[] = [
	{
		token: "{project.name}",
		title: "Nom du projet",
		type: DBType.projects,
		replace(item: VIPProject) {
			return item.name;
		}
	},
	{
		token: "{project.description}",
		title: "Description du projet",
		type: DBType.projects,
		replace(item: VIPProject) {
			return item.description?.replace(/^<p[^>]*>|<\/p>$/g, "") || "";
		}
	},
	{
		token: "{company.name}",
		title: "Nom du client",
		type: DBType.companies,
		replace(item: VIPCompany | string) {
			return item instanceof VIPCompany ? item.name : item;
		}
	},
	{
		token: "{contact.lastname}",
		title: "Nom du contact",
		type: DBType.contacts,
		replace(item: VIPContact | IVIPCertificateContact) {
			return item.last_name || "";
		}
	},
	{
		token: "{contact.firstname}",
		title: "Prénom du contact",
		type: DBType.contacts,
		replace(item: VIPContact | IVIPCertificateContact) {
			return item.first_name || "";
		}
	},
	{
		token: "{contact.civility}",
		title: "Civilité du contact",
		type: DBType.contacts,
		replace(item: VIPContact | IVIPCertificateContact) {
			return (item instanceof VIPContact ? item.getCivilityLabel() : item.civility) || "";
		}
	},
	{
		token: "{contact.position}",
		title: "Poste du contact",
		type: DBType.contacts,
		replace(item: VIPContact | IVIPCertificateContact) {
			return (item instanceof VIPContact ? item.position : item.service) || "";
		}
	},
];

export class TextTokens {
	public project!: VIPProject | null;
	public company!: VIPCompany | string | null;
	public contact!: VIPContact | IVIPCertificateContact | null;

	constructor(project: VIPProject | null = null, company: VIPCompany | string | null = null, contact: VIPContact | IVIPCertificateContact | null = null) {
		this.project = project || null;
		this.company = company || project?.company || contact?.company || null;
		this.contact = contact || project?.contact || (company instanceof VIPCompany ? company.contact : null) || null;
	}

	public hasTokens(text: string): boolean {
		return TOKENS.some(t => text.includes(t.token));
	}

	protected getTokenItem(token: ITextToken): any {
		switch (token.type) {
			case DBType.projects:
				return this.project;
			case DBType.companies:
				return this.company;
			case DBType.contacts:
				return this.contact;
			default:
				return null;
		}
	}

	public replace(text: string): string {
		return TOKENS.reduce((txt, t) => {
			let item = this.getTokenItem(t);
			if (!item) {
				return txt;
			}
			return txt.replace(new RegExp(t.token.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"), t.replace(item));
		}, text);
	}
}
